import { VehicleMaintenanceSchedule } from './fleet-management-models';
import { DataSource, CollectionViewer } from '@angular/cdk/collections';
import { Observable, of } from 'rxjs';
export class VehicleScheduleRecordDataSource extends DataSource<any> {
    data: Array<VehicleMaintenanceSchedule>;
    connect(): Observable<VehicleMaintenanceSchedule[]> {

        return of(this.data);
    }
    disconnect(collectionViewer: CollectionViewer): void {

    }
    setData(data: Array<VehicleMaintenanceSchedule>) {
        this.data = data;
    }

}
